import ComponentWrapper from "../../fragments/component-wrapper/ComponentWrapper";

export default function Heading({ block, index }) {
  if (!block) return null;

  const HeadingTag = index === 0 ? "h1" : "h2";
  const SubheadingTag = index === 0 ? "h2" : "h3";

  return (
    <ComponentWrapper className="BlockHeading">
      <div className="l-grid">
        <div className="l-grid__col l-grid__col--l-8-12">
          {block.subheading && (
            <SubheadingTag className="h6">{block.subheading}</SubheadingTag>
          )}
          {block.heading && (
            <HeadingTag className="h3">{block.heading}</HeadingTag>
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
}
